import React from 'react'
import SendIcon from './../../img/paper-plane-blue-24.png';


export class SendMessageForm extends React.Component {
    constructor() {
        super()
        this.state = {
            message: ''
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleChange(e) {
        this.setState({
            message: e.target.value
        })
    }

    handleSubmit(e) {
        e.preventDefault()
        this.props.sendMessage(this.state.message)
        this.setState({
            message: ''
        })
    }

    render() {
        return (
            <div className="chat-area-bottom">
                <form
                    onSubmit={this.handleSubmit}
                    className="write-message">
                    <div className="form-group">
                        <textarea
                            className="form-control"
                            rows="1"
                            onChange={this.handleChange}
                            value={this.state.message}
                            placeholder="Type a message"
                        />
                        {/*<button className="btn btn-rounded float-left" disabled={this.props.disabled} onClick={this.handleSubmit}>Send</button>*/}
                        <div className="div_sendIcon">
                            <div className="divSendIcon" disabled={this.props.disabled} onClick={this.handleSubmit}>
                                <img src={SendIcon} alt="Send" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}